import gql from 'graphql-tag';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';
import { clients } from '../../../util/clients';

const { backend } = clients.direct;

const defaultTransactionFileds = {
  _id: '',
  reasonCode: '',
  description: '',
};

export const taxReasonCode = {
  namespaced: true,
  state: () => ({
    selectedItems: [],
  }),
  mutations: {},
  actions: {
    async loadReasonCode({ commit, dispatch }, { criteria, postProcessTrans, baseCrudKey }) {
      let results;
      const gqlfields = defaultTransactionFileds;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
          query taxReasonCodeTrans($criteria:taxReasonCodeCriteriaType){
            taxReasonCodeTrans(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)}
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });

        clients.handleGQLErrors(results, commit);
        const { taxReasonCodeTrans } = results.data;
        const processedTransData = postProcessTrans
          ? postProcessTrans(taxReasonCodeTrans) : taxReasonCodeTrans;
        commit('base/crud/setItems', [baseCrudKey, processedTransData], {
          root: true,
        });
        return taxReasonCodeTrans;
      } catch (error) {
        dispatch('flashError', 'There was a problem getting Tax Reason Codes.', { root: true });
      }
      return [];
    },
    async upsertTaxReasonCode({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`
          mutation upsertTaxReasonCode($item:taxReasonCodeInputType!){
            upsertTaxReasonCode(upsert: $item) {
                ${fieldsToGqlString(defaultTransactionFileds)}
              }
            }
          `,
          variables: {
            item,
          },
          fetchPolicy: 'no-cache',
        });

        clients.handleGQLErrors(results, commit);
        const taxStateData = rootGetters['base/crud/items'](baseCrudKey);
        const newTaxType = results.data.upsertTaxReasonCode;
        const newList = mergeByIdNewAtTop(taxStateData || [], newTaxType);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
      } catch (error) {
        dispatch('flashError', 'There was a problem while upsert Tax Reason Codes!', { root: true });
      }
    },
    async deleteTaxReasonCode({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deleteTaxReasonCode ($id: ID!)  {
                deleteTaxReasonCode(id: $id) {
                      _id
                    }
                  }`,
          variables: {
            id: item._id,
          },
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data.deleteTaxReasonCode._id;
        const taxData = rootGetters['base/crud/items'](baseCrudKey);
        const updatedData = taxData.filter((d) => d._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
        commit('base/crud/setIsVisible', [baseCrudKey, false], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem deleting the Tax Reason Codes', { root: true });
      }
    },
  },
};

export default taxReasonCode;
